export default function memoize(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/memoize.js
// module id = 1572
// module chunks = 22